
import React from 'react';
import { ArrowRight } from 'lucide-react';
import CTAButton from '../CTAButton';

const PricingHero = () => {
  const scrollToPricingTable = () => {
    const pricingTable = document.querySelector('[data-pricing-table]');
    if (pricingTable) {
      pricingTable.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return <section className="pt-32 pb-16 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#FEE6D8]/30 to-white" />
        <div className="absolute top-1/4 right-1/3 w-64 h-64 bg-[#003a70]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/3 left-1/4 w-48 h-48 bg-[#FEE6D8]/50 rounded-full blur-3xl" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 max-w-4xl text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-[#003a70] mb-6 lg:text-4xl">
          AI Tools for Smarter Conversations and Data Collection Priced for Every Business.
        </h1>
        
        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto md:text-lg">
          Choose the plan that fits your needs. Upgrade, downgrade, or cancel anytime.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <CTAButton 
            variant="primary" 
            className="group !py-3 !px-6 !text-base !min-h-[48px] !rounded-lg" 
            onClick={scrollToPricingTable}
          >
            <span className="flex items-center">
              Select a Plan
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </CTAButton>
          
          <CTAButton 
            variant="secondary" 
            className="group !py-3 !px-6 !text-base !min-h-[48px] !rounded-lg"
            to="/book-demo"
          >
            <span className="flex items-center">
              Book a Demo
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </CTAButton>
        </div>
      </div>
    </section>;
};

export default PricingHero;
